import React from 'react'
import { useTranslation } from 'react-i18next'

import Box from '@/modules/components/Box'
import Flex from '@/modules/components/Flex'
import Typography from '@/modules/components/Typography'

import type { CompanySec } from '../../data/types'
import { CompanyCategory } from './CompanyCategory'

export const CompanyMenu = ({
  company,
  onClickMenuLink,
}: {
  company: CompanySec[]
  onClickMenuLink: () => void
}) => {
  const { t } = useTranslation('navigation')

  return (
    <Box pl={5} pr={8}>
      {company.map(({ tTitle, items }, i) => {
        const itemFirstCol = []
        const itemSecondCol = []

        for (let i = 0; i < items.length; i++) {
          if (i % 2 === 0) {
            itemFirstCol.push(items[i])
          } else {
            itemSecondCol.push(items[i])
          }
        }

        return (
          <Box key={tTitle}>
            <Flex pt={4} pb={'12px'}>
              {tTitle && (
                <Typography
                  variant="h5"
                  color="secondaryDarkGrey"
                  flex={[1 / items.length + 1]}
                  minWidth={['208px']}
                  maxWidth={['338px']}
                  width="max-content"
                >
                  {t(tTitle)}
                </Typography>
              )}
              <Flex width="516px" flexDirection={'row'}>
                <Flex flexDirection={'column'}>
                  {itemFirstCol.map(({ tTitle, tDesc, href }) => (
                    <Flex flexDirection={'column'} key={tTitle} width="258px">
                      <CompanyCategory
                        href={href}
                        tTitle={tTitle}
                        tDesc={tDesc}
                        translateFn={t}
                        onClick={onClickMenuLink}
                      />
                    </Flex>
                  ))}
                </Flex>
                <Flex flexDirection={'column'}>
                  {itemSecondCol.map(({ tTitle, tDesc, href }) => (
                    <Flex flexDirection={'column'} key={tTitle} width="258px">
                      <CompanyCategory
                        href={href}
                        tTitle={tTitle}
                        tDesc={tDesc}
                        translateFn={t}
                        onClick={onClickMenuLink}
                      />
                    </Flex>
                  ))}
                </Flex>
              </Flex>
            </Flex>
            {i !== company.length - 1 && (
              <Box height={0.5} bg="secondaryDarkGrey" />
            )}
          </Box>
        )
      })}
    </Box>
  )
}
